/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClientCompanyBillingInfoParam
 */
export interface ClientCompanyBillingInfoParam {
    /**
     * 
     * @type {string}
     * @memberof ClientCompanyBillingInfoParam
     */
    billingContact: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ClientCompanyBillingInfoParam
     */
    otherBillingContacts?: Array<string>;
}

/**
 * Check if a given object implements the ClientCompanyBillingInfoParam interface.
 */
export function instanceOfClientCompanyBillingInfoParam(value: object): value is ClientCompanyBillingInfoParam {
    if (!('billingContact' in value) || value['billingContact'] === undefined) return false;
    return true;
}

export function ClientCompanyBillingInfoParamFromJSON(json: any): ClientCompanyBillingInfoParam {
    return ClientCompanyBillingInfoParamFromJSONTyped(json, false);
}

export function ClientCompanyBillingInfoParamFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientCompanyBillingInfoParam {
    if (json == null) {
        return json;
    }
    return {
        
        'billingContact': json['billingContact'],
        'otherBillingContacts': json['otherBillingContacts'] == null ? undefined : json['otherBillingContacts'],
    };
}

export function ClientCompanyBillingInfoParamToJSON(value?: ClientCompanyBillingInfoParam | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'billingContact': value['billingContact'],
        'otherBillingContacts': value['otherBillingContacts'],
    };
}

